import { Text } from '@kanda-libs/ks-design-library';
import type { StringIndexedObject } from '@kanda-libs/ks-component-ts';

interface ViewComponentProps {
  /**
   * Card title
   */
  title?: string;
  /**
   * Text
   */
  text?: string;
  /**
   * Text
   */
  classNames?: StringIndexedObject;
  /**
   * Is loading
   */
  isLoading?: boolean;
}

const ViewComponent = ({
  title,
  text,
  classNames = {},
  isLoading,
}: ViewComponentProps) => (
  <div className={classNames.cardContainer}>
    <Text
      text={title as string}
      className={classNames.title}
      isLoading={isLoading}
      skeletonProps={{
        width: 80,
      }}
    />
    <Text
      text={text as string}
      className={classNames.text}
      isLoading={isLoading}
      skeletonProps={{
        width: 60,
      }}
    />
  </div>
);

ViewComponent.defaultProps = {
  title: '',
  text: '',
  classNames: {},
  isLoading: false,
};

ViewComponent.displayName = 'TextCard-view';

export default ViewComponent;
